export const GRADES = {
  1: "Nouvelle Recrue",
  2: "Initié",
  3: "Débutant",
  4: "Apprenti",
  5: "Amateur",
  6: "Pratiquant",
  7: "Régulier",
  8: "Habitué",
  9: "Motivé",
  10: "Déterminé",
  11: "Confirmé",
  12: "Passionné",
  13: "Engagé",
  14: "Acharné",
  15: "Athlète",
  16: "Guerrier",
  17: "Vétéran",
  18: "Expert",
  19: "Spécialiste",
  20: "Élite",
  21: "Force de la Nature",
  22: "Machine",
  23: "Cyborg",
  24: "Bulldozer",
  25: "Phénomène",
  26: "Colosse",
  27: "Mastodonte",
  28: "Béhémoth",
  29: "Goliath",
  30: "Titan",
  31: "Hercule",
  32: "Achille",
  33: "Spartiate",
  34: "Gladiateur",
  35: "Centurion",
  36: "Héros",
  37: "Gardien",
  38: "Protecteur",
  39: "Conquérant",
  40: "Demi-Dieu",
  41: "Prodige",
  42: "Icône",
  43: "Mythe",
  44: "Légende",
  45: "Légende Vivante",
  46: "Maître Absolu",
  47: "Empereur",
  48: "Invincible",
  49: "Divinité",
  50: "Masse-ter"
};

export const getGrade = (level) => {
  if (level <= 50) return GRADES[level];
  return "Masse-terclass";
};

export const getLevelInfo = (totalXp) => {
  let level = 1;
  let xpForNextLevel = 100;
  let accumulatedXp = 0;

  // New XP Formula: Level N to N+1 takes N * 100 XP
  // Level 1: 0 to 99 (requires 100)
  // Level 2: 100 to 299 (requires 200)
  // Level 3: 300 to 599 (requires 300)
  while (totalXp >= accumulatedXp + xpForNextLevel) {
    accumulatedXp += xpForNextLevel;
    level++;
    xpForNextLevel = level * 100;
  }

  const xpInCurrentLevel = totalXp - accumulatedXp;
  const progress = (xpInCurrentLevel / xpForNextLevel) * 100;

  return { 
    level, 
    progress, 
    xpInCurrentLevel, 
    xpForNextLevel, 
    totalXp,
    grade: getGrade(level)
  };
};
